import {Divider} from "../basic/Divider";
import {ReactNode} from "react";
import {Icon} from "@iconify/react";

function FooterButton({ icon, href, children }: { icon?: string, href?: string, children: ReactNode }) {
    return <a className={"flex gap-2 items-center text-sub hover:text-main"} href={href}>
        {/* eslint-disable-next-line react/jsx-no-undef */}
        {icon && <Icon className={"text-lg"} icon={icon} />}
        {children}
    </a>
}
export function Footer() {
    return (
        <div className={"w-full bg-background"}>
            <div className={"content-limit py-8 px-4 space-y-1"}>
                <div className={"grid grid-cols-1 sm:grid-cols-4 md:grid-cols-6 gap-2"}>
                    <FooterButton icon={"pixelarticons:mail"}>
                        联系我们
                    </FooterButton>
                    <FooterButton icon={"pixelarticons:book-open"}>
                        隐私政策
                    </FooterButton>
                    <FooterButton icon={"pixelarticons:book-open"}>
                        使用条款
                    </FooterButton>
                </div>
                <div className={"py-4"}>
                    <Divider />
                </div>
                <div>Copyright © 2024 PG Network Inc. 保留所有权利。</div>
                <div className={"flex justify-center text-sub text-sm gap-2"}>
                    <a
                        className={"hover:text-main"}
                        href={"http://beian.miit.gov.cn"}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        鲁ICP备2021027793号-4
                    </a>
                    {/*<a className={"hover:text-main"}>营业执照</a>*/}
                </div>
            </div>
        </div>
    );
}

